(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["utoya-kisisel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('utoya-personalizer')) {
    class UtoyaPersonalizer extends HTMLElement {
      connectedCallback() {
        this.files = [];
        this.formId = this.dataset.formId;
        this.max = parseInt(this.dataset.fileMax || '15', 10);
        this.picker = this.querySelector('.utoya-p__picker');
        this.list = this.querySelector('.utoya-p__files');
        this.hiddenBox = this.querySelector('.utoya-p__hidden-inputs');
        this.drop = this.querySelector('.utoya-p__drop');
        const onPick = () => { if (!this.picker.files || !this.picker.files.length) return; this.addFiles(this.picker.files); this.picker.value = ''; };
        this.picker?.addEventListener('change', onPick);
        this.picker?.addEventListener('input', onPick);
        ['dragover', 'dragenter'].forEach((e) => this.drop?.addEventListener(e, (ev) => { ev.preventDefault(); this.drop.classList.add('is-over'); }));
        ['dragleave', 'drop'].forEach((e) => this.drop?.addEventListener(e, () => this.drop.classList.remove('is-over')));
        this.drop?.addEventListener('drop', (ev) => { ev.preventDefault(); this.addFiles(ev.dataTransfer.files); });
        this.querySelectorAll('.utoya-p__addon-input').forEach((i) => i.addEventListener('change', () => this.updateExtras()));
        this.onSubmit = this.onSubmit.bind(this);
        this.form = document.getElementById(this.formId);
        window.addEventListener('submit', this.onSubmit, true);
      }
      disconnectedCallback() { window.removeEventListener('submit', this.onSubmit, true); }
      addFiles(fileList) {
        for (const f of fileList) {
          if (this.files.some((x) => x.name === f.name && x.size === f.size && x.lastModified === f.lastModified)) continue;
          if (this.files.length >= this.max) { alert('En fazla ' + this.max + ' dosya yükleyebilirsiniz.'); break; }
          if (f.size > 20 * 1024 * 1024) { alert(f.name + ' 20 MB sınırını aşıyor.'); continue; }
          this.files.push(f);
        }
        this.render();
      }
      render() {
        this.list.innerHTML = '';
        this.hiddenBox.innerHTML = '';
        this.files.forEach((f, i) => {
          const li = document.createElement('li');
          const isImg = f.type.startsWith('image/') && !/heic/i.test(f.type + f.name);
          if (isImg) { const img = document.createElement('img'); img.src = URL.createObjectURL(f); img.alt = ''; li.appendChild(img); }
          else { const s = document.createElement('span'); s.className = 'utoya-p__file-ext'; s.textContent = (f.name.split('.').pop() || '').toUpperCase(); li.appendChild(s); }
          const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', f.name + ' kaldır'); b.textContent = '×';
          b.addEventListener('click', () => { this.files.splice(i, 1); this.render(); });
          li.appendChild(b); this.list.appendChild(li);
          const input = document.createElement('input');
          input.type = 'file'; input.name = 'properties[Fotoğraf ' + (i + 1) + ']'; input.setAttribute('form', this.formId);
          const dt = new DataTransfer(); dt.items.add(f); input.files = dt.files;
          this.hiddenBox.appendChild(input);
        });
        this.drop.querySelector('.utoya-p__drop-text').innerHTML = this.files.length
          ? '<strong>' + this.files.length + ' dosya seçildi</strong> · eklemek için tıkla'
          : '<strong>Fotoğraf seç</strong> veya buraya sürükle';
      }
      selectedAddons() { return [...this.querySelectorAll('.utoya-p__addon-input:checked')]; }
      updateExtras() {
        const sel = this.selectedAddons();
        const total = sel.reduce((s, i) => s + parseInt(i.dataset.price, 10), 0);
        const p = this.querySelector('.utoya-p__extras');
        p.hidden = !sel.length;
        if (sel.length) {
          const fmt = new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', minimumFractionDigits: 0, maximumFractionDigits: 2 });
          this.querySelector('.utoya-p__extras-total').textContent = '+' + fmt.format(total / 100);
        }
      }
      async onSubmit(event) {
        if (!this.form) this.form = document.getElementById(this.formId);
        if (event.target !== this.form) return;
        if (this.form.dataset.utoyaAddonsDone === '1') { delete this.form.dataset.utoyaAddonsDone; return; }
        const sel = this.selectedAddons();
        if (!sel.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const qty = parseInt(new FormData(this.form).get('quantity') || '1', 10) || 1;
        const items = sel.map((i) => ({ id: parseInt(i.value, 10), quantity: qty, properties: { 'Bağlı ürün': this.dataset.productTitle } }));
        try {
          const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
          if (!res.ok) throw new Error('addon');
        } catch (e) { console.error(e); }
        this.form.dataset.utoyaAddonsDone = '1';
        this.form.requestSubmit();
      }
    }
    customElements.define('utoya-personalizer', UtoyaPersonalizer);
  }
  } catch(e) { console.error(e); }
})();

})();
